var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCovidRequestGuest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.696 22.688v-5.28a2.45 2.45 0 012.434-2.434h3.03a2.45 2.45 0 012.435 2.433v5.281H2.696zM17.804 22.688v-5.28a2.45 2.45 0 012.434-2.434h3.03a2.45 2.45 0 012.434 2.433v5.281h-7.898z",
    fill: "#EDF2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.666 24.111v-7.53a3.39 3.39 0 013.398-3.399h4.27a3.39 3.39 0 013.399 3.399v7.576H8.666v-.046z",
    fill: "#EDF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.064 14.072a2.502 2.502 0 00-2.51 2.509v6.688h9.29V16.58a2.502 2.502 0 00-2.51-2.51h-4.27zM7.777 16.58a4.28 4.28 0 014.287-4.287h4.27a4.28 4.28 0 014.288 4.287v7.577c0 .49-.398.889-.89.889H8.667a.889.889 0 01-.89-.89v-7.576zM14.222 4.474a2.51 2.51 0 100 5.019 2.51 2.51 0 000-5.019zm-4.287 2.51a4.287 4.287 0 118.574 0 4.287 4.287 0 01-8.574 0zM6.553 7.013a3.001 3.001 0 100 6.002 3.001 3.001 0 000-6.002zm-1.223 3a1.223 1.223 0 112.447 0 1.223 1.223 0 01-2.447 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.585 17.407c0-.84.704-1.545 1.545-1.545h3.03c.197 0 .386.039.56.108a3.38 3.38 0 01.765-1.607 3.279 3.279 0 00-1.324-.278H5.13a3.339 3.339 0 00-3.323 3.322v5.281c0 .49.398.889.889.889h5.97v-1.778H3.585v-4.392zM19.733 23.577h5.97c.49 0 .888-.398.888-.889v-5.28c0-1.824-1.5-3.324-3.323-3.324h-3.03c-.47 0-.918.1-1.325.279.386.448.656 1 .765 1.607.174-.07.363-.108.56-.108h3.03c.841 0 1.545.704 1.545 1.545V21.8h-5.08v1.778z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.89 7.013a3.001 3.001 0 100 6.002 3.001 3.001 0 000-6.002zm-1.223 3a1.223 1.223 0 112.447.001 1.223 1.223 0 01-2.447 0z",
    fill: props.color
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.289 20.49a6.223 6.223 0 10-8.801 8.8 6.223 6.223 0 008.8-8.8z",
    fill: "#54822B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.555 28l-2.472-2.473 1.257-1.257 1.215 1.215 3.663-3.662 1.257 1.257-4.92 4.92z",
    fill: "#fff"
  })));
}

export default SvgIconCovidRequestGuest;